import { Paper } from "@mui/material";
import { FieldArray, FormikProvider } from "formik";
import { apenasNumeros } from "@/services/utils";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { formataValorSimulador } from "../../../../services/utils";

export default function ItemPagamentoBoletos({ formik }) {
  return (
    <>
      {formik.values.boletos.length > 0 && (
        <FormikProvider value={formik}>
          <FieldArray
            name="boletos"
            render={() => (
              <>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Paper variant="outlined" sx={{ p: 1, pb: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={12} align="center">
                        <img
                          src="/icon-boleto2.png"
                          alt=""
                          style={{ height: "2.5rem" }}></img>
                      </Grid>
                      {formik.values.boletos.map((boleto, index) => (
                        <Grid size={12} key={`codigoBarras${index}`}>
                          <Grid container spacing={1}>
                            <Grid size={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                }}>
                                <TextField
                                  label={"Código de barras do boleto"}
                                  fullWidth
                                  variant="standard"
                                  multiline
                                  slotProps={{
                                    htmlInput: {
                                      maxLength: 60,
                                    },
                                    style: {
                                      paddingRight: "25px",
                                    },
                                  }}
                                  autoComplete="off"
                                  value={boleto.barcode}
                                  onChange={(e, value) => {
                                    formik.setFieldValue(
                                      `boletos[${index}].barcode`,
                                      apenasNumeros(e.target.value)
                                    );
                                  }}
                                  onBlur={(e) => {
                                    const valor = apenasNumeros(
                                      formik.values.boletos[index].barcode
                                    );
                                    formik.setFieldValue(
                                      `boletos[${index}].barcode`,
                                      valor
                                    );
                                  }}
                                />
                                <ClearIcon
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `boletos`,
                                      formik.values.boletos.filter(
                                        (boleto, i) => i !== index
                                      )
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                  sx={{
                                    color: "action.active",
                                    mr: 1,
                                    ml: -3,
                                    zIndex: 1,
                                    my: 0.5,
                                  }}
                                />
                              </Box>
                            </Grid>
                            <Grid size={12}>
                              <TextField
                                name="amount"
                                type="number"
                                label={"Valor do boleto"}
                                autoComplete="off"
                                onWheel={() => document.activeElement.blur()}
                                variant="standard"
                                placeholder="R$ 0,00"
                                slotProps={{
                                  inputLabelProps: {
                                    shrink: true,
                                  },
                                }}
                                value={boleto.amount}
                                onChange={(e, value) => {
                                  formik.setFieldValue(
                                    `boletos[${index}].amount`,
                                    formataValorSimulador(e.target.value)
                                  );
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </>
            )}
          />
        </FormikProvider>
      )}
    </>
  );
}
